import request from '@/utils/request';

// 昵称管理-列表
export function getNormalNicknameListApi(params) {
  return request({
    url: '/admin/get_normal_nickname_list',
    method: 'get',
    params,
  });
}

// 昵称管理-保存（新增/编辑）
export function saveNormalNicknameApi(data) {
  return request({
    url: '/admin/save_normal_nickname',
    method: 'post',
    data,
  });
}

// 昵称管理-删除
export function deleteNormalNicknameApi(id) {
  return request({
    url: `/admin/del_normal_nickname/${id}`,
    method: 'delete',
  });
}
